if (!customElements.get('brand-logos')) {
  customElements.define('brand-logos', class extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('is-ready')) return;
      const list = this.querySelector('.brand-logos__list');
      if (!list.children.length) return;
      const clone = list.cloneNode(true);
      clone.classList.add('brand-logos__clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('aria-labelledby');
      // Decorative copies stay out of focus while retaining their collection links.
      clone.addEventListener('pointerdown', event => event.preventDefault());
      clone.querySelectorAll('a').forEach(link => link.tabIndex = -1);
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(item => item.removeAttribute('data-shopify-editor-block'));
      list.after(clone);
      this.classList.add('is-ready');
    }
  });
}
